import { render } from "./Tasks.vue?vue&type=template&id=c8a90f7e&ts=true"
import script from "./Tasks.vue?vue&type=script&lang=ts"
export * from "./Tasks.vue?vue&type=script&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=c8a90f7e&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__